import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section className="py-24 lg:py-32 bg-[#F2F2F2] grid-bg">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16">
          <span className="label-text text-[rgba(35,35,35,0.5)] mb-4 block">Feedback</span>
          <h2 className="section-title">Testimonials</h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="card-sharp p-8 relative"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6">
                <Quote className="w-8 h-8 text-[#38FF62] opacity-30" />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, idx) => (
                  <Star key={idx} className="w-4 h-4 fill-[#38FF62] text-[#38FF62]" />
                ))}
              </div>

              {/* Content */}
              <p className="font-body text-lg text-[rgba(35,35,35,0.8)] mb-6 leading-relaxed">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="pt-4 border-t border-[rgba(35,35,35,0.1)]">
                <h4 className="font-display font-semibold text-[#232323]">
                  {testimonial.name}
                </h4>
                <p className="font-mono text-xs uppercase tracking-wider text-[rgba(35,35,35,0.5)]">
                  {testimonial.role}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;